export const oauthBroadcastChannel = new BroadcastChannel("oauth");
